<template>
  <div id="bar">
    <p class="mb-1 text-center">
      <small class="font-weight-bold text-info">{{ value }}</small>
    </p>
    <div class="bar-background">
      <div
        :style="dynamicBar"
        class="dynamic-bar"
      />
    </div>
    <p class="m-0 text-center">
      <small class="font-weight-bold">{{ name }}</small>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Bar',

  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    colorOne: {
      type: String,
      default: '#666'
    },
    colorTwo: {
      type: String,
      default: '#666'
    }
  },

  computed: {
    dynamicBar () {
      return {
        height: `${this.value / this.total * 100 || 0}%`,
        backgroundImage: `linear-gradient(180deg, ${this.colorOne} 0%, ${this.colorTwo} 100%)`
      }
    }
  }
}
</script>

<style scoped>
.bar-background {
  background-color: #dedede;
  border-radius: 20px;
  width: 25px;
  height: 200px;
  display: flex;
  align-items: flex-end;
  margin: auto;
}
.dynamic-bar {
  width: 25px;
  max-height: 100%;
  border-radius: 20px;
  transition: height 2s;
}
</style>
